export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.37 2.724a1 1 0 011.337.068L17.914 8H22a1 1 0 01.965 1.262l-3 11A1 1 0 0119 21H5a1 1 0 01-.965-.738l-3-11A1 1 0 012 8h4.086l5.207-5.208.076-.068zM5.763 19h12.472l2.454-9H3.31l2.454 9zm3.15-11h6.172L12 4.914 8.914 8z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};